import { useState, useEffect } from 'react'
import Header from './Header.jsx'
import PageMenu from './PageMenu.jsx'
import Footer from './PageFooter_temporary.jsx'
import getImageUrl from './get-image-url.js'
import PageHeader from './PageHeader.jsx'
import apiFetch from '@wordpress/api-fetch'
import Breadcrumb from './Breadcrumb.jsx'
import Categories from './Categories.jsx'
import { format } from 'date-fns'
import Association from './AssociationPost.jsx'
import { useMediaQuery } from 'react-responsive'

const postID = document.getElementById('root').getAttribute('data-post-id')
const site_url = import.meta.env.VITE_SITE_URL

function App() {
  const [data, setData] = useState(null)
  const isPC = useMediaQuery({
    query: '(min-width: 1024px)',
  })

  useEffect(() => {
    apiFetch({ path: `${site_url}/wp-json/wp/v2/posts/${postID}` }).then((posts) => {
      setData(posts)
    })
  }, [])

  const CatAndDate = () => {
    return (
      <>
        <ul className="mt-[30px] flex flex-wrap gap-x-[10px]">
          {data &&
            data.categories.map((item, index) => (
              <Categories
                key={index}
                id={item}
              />
            ))}
        </ul>
        <p className="date mt-[20px] text-right">
          {data && format(new Date(data.date), 'yyyy.MM.dd')}
        </p>
        <style jsx>{`
          h2 {
            text-align: center;
            font: normal normal bold 40px/58px Noto Sans JP;
            letter-spacing: 0px;
            color: #2964b6;
          }
          .date {
            font: normal normal 500 20px/48px Noto Sans JP;
            letter-spacing: 1px;
          }
          .content {
            font: normal normal normal 22px/40px Noto Sans JP;
          }
          @media screen and (min-width: 1024px) {
            h1 {
              font: normal normal 500 40px/58px Noto Sans JP;
              border-bottom: 2px solid #000;
              padding-bottom: 18px;
            }
            h2 {
              text-align: center;
              font: normal normal bold 40px/58px Noto Sans JP;
              letter-spacing: 0px;
              color: #2964b6;
            }
            .date {
              font: normal normal 500 20px/48px Noto Sans JP;
              letter-spacing: 1px;
            }
            .content {
              font: normal normal normal 22px/40px Noto Sans JP;
            }
          }
        `}</style>
      </>
    )
  }

  return (
    <>
      <Header />
      {isPC ? <PageMenu /> : ''}
      <main>
        <PageHeader
          image={getImageUrl('NEWS.png')}
          title={'お知らせ'}
        />
        <div className="content-area">
          <Breadcrumb
            current={data && data.title.rendered}
            site_url={import.meta.env.VITE_SITE_URL}
            items={[
              {
                url: '/news-list/',
                title: 'お知らせ',
              },
            ]}
          />
          <h1>{data && data.title.rendered}</h1>
          {isPC ? (
            <CatAndDate />
          ) : (
            <div className="flex justify-between items-center">
              <CatAndDate />
            </div>
          )}
          <div
            className="content break-all post-content"
            dangerouslySetInnerHTML={{ __html: data && data.content.rendered }}
          ></div>
          <div className="flex flex-wrap gap-y-2 justify-between mt-9">
            <div>
              {window.next_post && (
                <a
                  href={window.next_post.link}
                  className="font-bold"
                >
                  {'<< ' + window.next_post.post_title}
                </a>
              )}
            </div>
            <div>
              {window.prev_post && (
                <a
                  href={window.prev_post.link}
                  className="font-bold"
                >
                  {window.prev_post.post_title + ' >>'}
                </a>
              )}
            </div>
          </div>
          {data && data.crb_association.length ? (
            <div className="mt-[128px]">
              <h2>関連記事</h2>
              <div className="grid md:grid-cols-3 gap-7 mt-[50px]">
                {data.crb_association.map((item) => {
                  return (
                    <Association
                      key={item.id}
                      id={item.id}
                    />
                  )
                })}
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </main>
      <Footer />
      <style jsx>{`
        h1 {
          font-size: calc(40vw / 7.5);
          border-bottom: 2px solid #000;
          padding-bottom: 18px;
          margin-top: 24px;
        }
        h2 {
          text-align: center;
          font: normal normal bold 40px/58px Noto Sans JP;
          letter-spacing: 0px;
          color: #2964b6;
        }
        .date {
          font: normal normal 500 20px/48px Noto Sans JP;
          letter-spacing: 1px;
        }

        .content {
          font: normal normal normal 18px Noto Sans JP;
        }

        @media screen and (min-width: 1024px) {
          h1 {
            font: normal normal 500 40px/58px Noto Sans JP;
            border-bottom: 2px solid #000;
            padding-bottom: 18px;
          }
          h2 {
            text-align: center;
            font: normal normal bold 40px/58px Noto Sans JP;
            letter-spacing: 0px;
            color: #2964b6;
          }
          .date {
            font: normal normal 500 20px/48px Noto Sans JP;
            letter-spacing: 1px;
          }
        }
      `}</style>
    </>
  )
}

export default App
